import { useLayoutContext, TouchableBox, AHText } from "arkh";
import { StyleProp, ViewStyle } from "react-native";

export function ListItemCTAWeb(props: {
  placeholder: React.ReactNode;
  onPress(): void;
  style?: StyleProp<ViewStyle>;
  disabled?: boolean;
}) {
  const layout = useLayoutContext();
  return (
    <TouchableBox
      borderColor="border-primary"
      color="surface"
      onPress={props.onPress}
      disabled={props.disabled}
      style={[
        {
          borderWidth: 1,
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-between",
          borderRadius: layout.radius.medium,
          paddingLeft: layout.space.small,
          paddingRight: layout.space.small,
          height: layout.circle.smallMedium,
        },
        props.style,
      ]}
    >
      <AHText>{props.placeholder}</AHText>
    </TouchableBox>
  );
}
